import React, {Component} from 'react';

export default function UserContextMenuItem(props) {
    let {onClick = null, href = null, target = '', label, disabled = false} = props;

    let className = '';
    if (disabled) className = 'disabled';

    return <li className={className}><a onClick={!disabled ? onClick : null} href={!disabled ? href : null} target={target}>{label}</a></li>;
}


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UserContextMenuItem/index.js